



















import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import Enumerable from "linq";
import { ModelEditableMixin } from "../../system/mixins";
import FormatSetDirectoryFilter from "./FormatSetDirectoryFilter.vue";
import FormatSetFilter from "./FormatSetFilter.vue";
import FormatSetReferenceFilter from "./FormatSetReferenceFilter.vue";
import { FormatSetDirectoryFilterParameter, FormatSetFilterParameter, FormatSetTreeFilterParameter } from ".";

@Component({
  components: {
    FormatSetDirectoryFilter,
    FormatSetFilter,
    FormatSetReferenceFilter,
  },
})
export default class FormatSetTreeFilter extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: FormatSetTreeFilterParameter) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: FormatSetTreeFilterParameter) => T, defaultValue: T) => T;

  @Prop()
  expand: boolean;

  data(): any {
    return {
      activeNames: [],
    };
  }
  activeNames: string[];

  get conditionsString(): string {
    const text = Enumerable.from([
      this.directoryNameConditionString,
      this.formatSetNameConditionString,
      this.formatNameConditionString,
    ])
    .where(t => !!t)
    .toArray()
    .join("");
    return "絞り込み：" + (text ? text : "なし");
  }

  private formatConditionString(name: string, value: string): string {
    return value
      ? (name + "【" + value + "】")
      : "";
  }

  get directoryNameConditionString(): string {
    return this.formatConditionString(
      "フォルダ名称",
      this.directory ? this.directory.name.keyword : null);
  }

  get formatSetNameConditionString(): string {
    return this.formatConditionString(
      "文書セット名称",
      this.set ? this.set.name.keyword : null);
  }

  get formatNameConditionString(): string {
    return this.formatConditionString(
      this.$wording.format.name + "名称",
      this.set ? this.set.formatName.keyword : null);
  }

  get set(): FormatSetFilterParameter {
    return this.readPropertyOrDefault(s => s.set, new FormatSetFilterParameter());
  }

  set set(source: FormatSetFilterParameter) {
    this.writePropertyWhenValid(s => s.set = source);
  }

  get directory(): FormatSetDirectoryFilterParameter {
    return this.readPropertyOrDefault(s => s.directory, new FormatSetDirectoryFilterParameter());
  }

  set directory(source: FormatSetDirectoryFilterParameter) {
    this.writePropertyWhenValid(s => s.directory = source);
  }

  @Watch("expand")
  onExpandUpdated(newValue: boolean, oldValue: boolean): void {
    this.activeNames = newValue
      ? ["1"]
      : [];
  }

  clear(): void {
    this.writePropertyWhenValid(s => s.clear());
  }
}
